import React, { useState } from 'react';
import { ApButtonSecondary } from '@alixpartners/ui-components';

import {
	Wrapper,
	Textarea,
	StyledInput,
	ActionsWrapper,
} from './ExpandableInput.styles';

export const ExpandableInput = ({ value, onChange, maxLength }) => {
	const [isFocused, setFocused] = useState(false);
	const [isCollapsed, setCollapsed] = useState(true);

	const toggle = () => {
		setCollapsed(!isCollapsed);
	};

	// Put cursor at the end on focus
	const handleFocus = e => {
		e.currentTarget.setSelectionRange(
			e.currentTarget.value.length,
			e.currentTarget.value.length
		);

		setFocused(true);
	};

	const handleBlur = () => {
		setFocused(false);
	};

	return (
		<Wrapper>
			{isCollapsed ? (
				<StyledInput value={value} onChange={onChange} onClick={toggle} />
			) : (
				<React.Fragment>
					<Textarea
						autoFocus
						value={value}
						onChange={onChange}
						onFocus={handleFocus}
						onBlur={handleBlur}
						maxLength={maxLength}
					/>
					<ActionsWrapper isActive={isFocused}>
						<ApButtonSecondary onClick={toggle}>Close</ApButtonSecondary>
					</ActionsWrapper>
				</React.Fragment>
			)}
		</Wrapper>
	);
};

export default ExpandableInput;
